export default __webpack_public_path__ + "static/media/stop-watch.bbc815ff.svg";